
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './style/global.css';
import Home from './pages/Home';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './utils/ScrollToTop';
import PageNotFound from './pages/PageNotFound';
import Medicines from './pages/Medicines';
import DrugDetails from './pages/DrugDetails';
import PriceCompare from './pages/PriceCompare';
import MakeVoiceHear from './pages/MakeVoiceHear';
import Contact from './pages/Contact';
import HealthcareInAmerica from './pages/HealthcareInAmerica';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Header />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/medicines' element={<Medicines />} />
            <Route path='/drug-details' element={<DrugDetails />} />
            <Route path='/price-compare' element={<PriceCompare />} />
            <Route path='/contact-congressman' element={<MakeVoiceHear />} />
            <Route path='/healthcare' element={<HealthcareInAmerica />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/about' element={<Home />} />
            <Route path='/health-care-price' element={<HealthcareInAmerica />} />
            <Route path='/make-voice' element={<MakeVoiceHear />} />
            <Route path='/blog' element={<HealthcareInAmerica />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
